import { Routes } from '@angular/router';
import { AuthInitResolverService, AuthInitService, provideInroomStores, RoomResolverService } from '@era/inroom';
import { GroupResolver, UserResolver } from '@era/security';
import * as InRoomSdk from '@rocksoft/inroom-sdk';
import {
  AlarmService,
  BlindsService,
  ClimateService,
  LightsService,
  LocationsService,
  MobileFolioService,
  MobileReservationService,
  MoodsService,
  ReservationService,
  RoomsService,
  StateService,
} from '@rocksoft/inroom-sdk';
import { AuthorizationGuard } from '../auth.guard';
import { FeatureGuard } from '../feature.guard';
import { PageErrorComponent } from '../pages/error';
import { LoginComponent } from '../pages/login';
import { DefaultComponent, FullscreenComponent } from '../pages/master';
import { PageNotFoundComponent } from '../pages/page-not-found';
import { PairConfirmPage, PairPage } from '../pages/pair';
import { PageUnauthorizedComponent } from '../pages/unauthorized';

export const APP_ROUTES: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: DefaultComponent,
    pathMatch: 'full',
  },
  {
    path: 'places',
    component: DefaultComponent,
    loadChildren: () => import('./locations.routes'),
    canMatch: [FeatureGuard, AuthorizationGuard],
    resolve: [GroupResolver, UserResolver],
  },
  {
    path: 'security',
    component: DefaultComponent,
    loadChildren: () => import('./security.routes'),
    canMatch: [FeatureGuard, AuthorizationGuard],
    resolve: [GroupResolver, UserResolver],
  },
  {
    path: 'devices',
    component: DefaultComponent,
    loadChildren: () => import('./devices.routes'),
    canMatch: [FeatureGuard, AuthorizationGuard],
  },
  {
    path: 'apps',
    component: DefaultComponent,
    loadChildren: () => import('./apps.routes'),
    canMatch: [FeatureGuard, AuthorizationGuard],
  },
  {
    path: 'virtual-room',
    component: DefaultComponent,
    loadChildren: () => import('./inroom.routes'),
    canMatch: [FeatureGuard, AuthorizationGuard],
    providers: [
      AuthInitResolverService,
      AuthInitService,
      RoomResolverService,
      AlarmService,
      ClimateService,
      BlindsService,
      LightsService,
      LocationsService,
      MoodsService,
      RoomsService,
      StateService,
      InRoomSdk.AuthenticationService,
      InRoomSdk.IReckonTelevisionService,
      MobileFolioService,
      ReservationService,
      MobileReservationService,
      ...provideInroomStores(),
    ],
    resolve: { auth: AuthInitResolverService },
  },
  {
    path: 'management',
    component: DefaultComponent,
    loadChildren: () => import('./management.routes'),
    canMatch: [FeatureGuard, AuthorizationGuard],
  },
  {
    path: 'mdm',
    component: DefaultComponent,
    loadChildren: () => import('./mdm.routes'),
    canMatch: [FeatureGuard, AuthorizationGuard],
  },
  {
    path: 'pair',
    pathMatch: 'full',
    component: PairPage,
  },
  {
    path: 'pair/:pairingCode',
    pathMatch: 'full',
    component: PairConfirmPage,
  },
  { path: 'error', component: PageErrorComponent },
  {
    path: '',
    component: FullscreenComponent,
    pathMatch: 'full',
    children: [
      { path: 'unauthorized', component: PageUnauthorizedComponent },
      { path: 'error', component: PageErrorComponent },
      { path: '**', component: PageNotFoundComponent },
    ],
  },
  {
    path: '**', // Fallback route: Shows DefaultComponent if no route was matched
    component: DefaultComponent,
    pathMatch: 'full',
  },
];
